class Announcements extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    const splide = new Splide(".splide", {
      type: "fade",
      drag: "free",
      arrows: false,
      pagination: false,
      perPage: 1,
      focus: "center",
      rewind: true,
      autoplay: true,
      interval: 5000,
    });

    splide.mount();
  }
}

if (!customElements.get("announcements-marquee")) {
  customElements.define("announcements-marquee", Announcements);
}
